import type { ProgressBackLink } from 'app/store/project/progresses-back-links/progresses-back-links.reducer';
import { createAction, props } from '@ngrx/store';

export const addBackLink = createAction('[Progresses Back Links Store] Add Back Link', props<ProgressBackLink>());
